import { isSirfAvailable } from "./sirf.js";
import { getAncillaries, getSubsidizedFares } from "../flightDetails/selectors.js";
export const getIsFlexibleTicketPreSelectedAtMeta = (state) => !!getAncillaries(state)?.flexibleTicket?.preSelected;
export const getIsFlexibleTicketAvailable = (state) => {
    const { fetchStatus: extraProductsStatus, extraProducts } = state.extraProducts;
    return extraProductsStatus === "success" ? !!extraProducts?.flexibleTicket : !!getAncillaries(state)?.flexibleTicket;
};
export const getIsCfarAvailable = (state) => {
    const { fetchStatus: extraProductsStatus, extraProducts } = state.extraProducts;
    return extraProductsStatus === "success"
        ? !!extraProducts?.cancelForAnyReason
        : !!getAncillaries(state)?.cancelForAnyReason;
};
export const getIsInsuranceAvailable = (state) => !!getAncillaries(state)?.travelInsurance;
export const getIsSpanishIslandsResidentFareAvailable = (store) => isSirfAvailable(getSubsidizedFares(store) || []);
export const getIsSeatMapAvailable = (state) => {
    const { fetchStatus: extraProductsStatus, extraProducts } = state.extraProducts;
    return extraProductsStatus === "success" ? !!extraProducts?.seatMap : !!getAncillaries(state)?.seatMap;
};
